import React from 'react';

// Internal modules
import type { IconProps } from './types';

export const InfoSpot = ({
  spotBgColor = '#FF9600',
}: IconProps = {}): React.ReactElement => (
  <svg
    fill="none"
    height="18"
    viewBox="0 0 18 18"
    width="18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M9 17C13.411 17 17 13.41 17 9C17 4.588 13.411 1 9 1C4.589 1 1 4.588 1 9C1 13.41 4.589 17 9 17ZM10 13C10 13.5523 9.55228 14 9 14C8.44772 14 8 13.5523 8 13L8 9C8 8.44772 8.44772 8 9 8C9.55228 8 10 8.44772 10 9V13ZM9 4C8.44772 4 8 4.44772 8 5C8 5.55229 8.44772 6 9 6C9.55228 6 10 5.55229 10 5C10 4.44772 9.55228 4 9 4Z"
      fill={spotBgColor}
      fillRule="evenodd"
    />
  </svg>
);
